import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { Trash2 } from 'lucide-react';

export const Delete = ({ onConfirm, disabled, size = 16 }) => {
  const [show, setShow] = useState(false);
  const normalizedSize =
    typeof size === 'number'
      ? size
      : size === 'sm'
        ? 14
        : size === 'lg'
          ? 18
          : Number(size) || 16;

  // Функции для открытия и закрытия модального окна
  const handleShow = () => {
    if (!disabled) {
      setShow(true);
    }
  };
  const handleClose = () => setShow(false);

  // Обработчик подтверждения удаления
  const handleConfirm = () => {
    onConfirm(); // Вызываем переданную функцию
    handleClose(); // Закрываем модальное окно
  };

  return (
    <>
      <button
        type="button"
        className="ui-icon-btn ui-icon-btn-danger"
        title={disabled ? 'Нельзя удалить элемент по умолчанию' : 'Удалить'}
        onClick={handleShow}
        disabled={disabled}
      >
        <Trash2 size={normalizedSize} />
      </button>

      {/* Модальное окно подтверждения */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Подтверждение удаления</Modal.Title>
        </Modal.Header>
        <Modal.Body>Вы уверены, что хотите удалить?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Отмена
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Удалить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
